import React, { useContext } from 'react';
import { BookingFormContext } from "../BookingFormProvider";
import FormRow from "../../../../Components/HorizontalForm/FormRow";
import { dateForDateInputFromState, dateFromState } from "../../../../Helpers/DateTimeHelper";
import AvailabilityIntervalSelectorDisabled
    from "../../../../Components/Inputs/Availability/AvailabilityIntervalSelectorDisabled";
import { differenceInMinutes, format } from "date-fns";
import TextField from "@mui/material/TextField";
import { formatPrice } from "../../../../Helpers/PaymentHelper";

const BookingFormTimeSectionDisabled = (props) => {

    const { booking } = useContext(BookingFormContext);

    return (
        <section className="section form-container full">
            <FormRow label="Date">
                <TextField
                    value={dateForDateInputFromState(booking.start)}
                    style={{ width: 140 }}
                    disabled
                />
            </FormRow>

            <FormRow label="Time">
                <TextField
                    value={`${format(dateFromState(booking.start), 'HH:mm')} - ${format(dateFromState(booking.end), 'HH:mm')}`}
                    style={{ width: 140 }}
                    disabled
                />
            </FormRow>

            {(!!booking.payment) && <>
                <FormRow label="Amount Paid">
                    {formatPrice(booking.payment?.total_amount, booking.payment?.currency_symbol)}
                </FormRow>

                <FormRow label="Payment Reference">
                    {booking.payment?.reference}
                </FormRow>
            </>}
        </section>
    );
};

BookingFormTimeSectionDisabled.propTypes = {};

BookingFormTimeSectionDisabled.defaultProps = {};

export default BookingFormTimeSectionDisabled;
